<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div mat-dialog-title>
  Edit Card
  <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
    <mat-icon class="mdi-24px center-self" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (!!data && data.card !== undefined && data.card !== null) {
<div mat-dialog-content>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input type="text" matInput [formControl]="cardNameFormControl" placeholder="Name (required)"
          (blur)="saveCard('name')" value="{{data.card.name}}">
        @if (cardNameFormControl.hasError('required')) {
        <mat-error>
          Name is <strong>required</strong>
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput [formControl]="cardDescriptionFormControl" placeholder="Description"
          (blur)="saveCard('description')" value="{{data.card.description}}"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()"
        style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
}
